
import ContactsBlock from '@/components/TheMain/components/ContactsBlock';
import RoundedTableCES1 from "~/components/TheMain/components/RoundedTableCES1";
import CoolLightBox from "vue-cool-lightbox";
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default {
  name: 'Ces1',
  components: { ContactsBlock,
  RoundedTableCES1,
    CoolLightBox
  },
  data() {
    return {
      images: [
        {url: '/images/R2004_CES1.jpg'}
      ],
      imageIndex: null,
      text: '        Ген <i>CES1</i> кодирует карбоксилэстеразу, участвующую в\n' +
        '        биотрансформации эндогенных и экзогенных веществ, в том числе\n' +
        '        лекарственных средств и пролекарств, и в биоинактивации эфиров, амидов,\n' +
        '        карбаматов тиоэфиров и локально-стабильных соединений. Нуклеотидная\n' +
        '        замена C на A в позиции -33 приводит к синтезу фермента со сниженной\n' +
        '        активностью, замедляющей катаболизм Ацил-КоА, ацилкарнитина,\n' +
        '        триацилглицерина, эфиров холестерина, дабигатран этексилата, аспирина,\n' +
        '        капецитабина, цилазаприла, клопидогрела, кокаина, эналаприла, героина,\n' +
        '        имидаприла, иринотекана, меперидина, метилфенидата, олмесартана,\n' +
        '        орлистата, осельтамивира, квинаприла, рамиприла, тэмолаприла, фталатов,\n' +
        '        бензоатов, пиретроидов, пиретринов, фосфорорганических соединений,\n' +
        '        пестицидов, антипиренов. Таким образом, мутации в <i>CES1</i> нарушают\n' +
        '        метаболические процессы, снижают устойчивость организма к ксенобиотикам\n' +
        '        и модифицируют фармакокинетику лекарственных препаратов.',
    }
  },
  head() {
    return {
      title: 'ГенТест CES1',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Набор для выявления полиморфизма в гене человека CES1 методом ПЦР-РВ',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
            'ГенТест CES1, R2004, тест система CES1, kit CES1, набор CES1, мутация CES1, горячая точка CES1, аллельный вариант CES1, скрининг CES1, полиморфизм CES1, CES1 c(-33)a, NG_012057.1:g.27467C> A, NM_001266.4:c.1165-33C> A, rs2244613',
        },
      ],
    }
  },
}
